import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { PhysiologicalDataApi } from '../../../apis/PhysiologicalDataApi/PhysiologicalDataApi';
import { IPhysiologicalType, PhysiologicalType } from '../PhysiologicalData';

export function useGetPhysiologicalTypes() {
    return useQuery({
        queryKey: [QueryKeys.physiologicalTypes],
        queryFn: async () => {
            const results: IPhysiologicalType[] = await PhysiologicalDataApi.getPhysiologicalTypes();
            return results.map(result => new PhysiologicalType(result));
        },
        enabled: true
    });
} 